import { ColorPicker } from "components";
import { AppointmentPhaseDropdown } from "components/dropdowns/reactselect/AppointmentPhaseDropdown";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React, { useState } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { StatusInfo } from "./models";
import { getAppointmentPhase } from "utilities";

interface StatusNewSectionProps {
  mainArea: server.dto.MainAreas
}

export const StatusNewSection = (props: StatusNewSectionProps) => {
  const { mainArea } = props;
  const [value, setValue] = useState<StatusInfo>({
    title: "",
    hexColor: "",
    appointmentPhase: getAppointmentPhase("option")
  });

  const onChange = (newData: Partial<StatusInfo>) => {
    setValue({ ...value, ...newData });
  };

  return <EditSectionTemplate
    submit={() => window.CoreApi.Status.Create({
      appointmentPhase: value.appointmentPhase.value,
      title: value.title,
      hexColor: value.hexColor,
      mainArea
    })}
    redirectUrl={(itemId) => routes.status_Detail(itemId).absolute}
    sections={[{
      type: "regular",
      key: "status",
      title: RESX.Status.resxStatus,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        renderEditNew: () => <RequiredTextInput
          validatorKey="title"
          maxLength={serverReference.constants.status.maxTitleLength}
          value={value.title}
          onChange={(title) => { onChange({ title }); }}
        />,
      }, {
        key: "appointmentPhase",
        label: RESX.Status.TreatAs,
        renderEditNew: () => <AppointmentPhaseDropdown
          value={value.appointmentPhase}
          onChange={(appointmentPhase) => { onChange({ appointmentPhase }); }}
        />,
        hidden: mainArea !== "show",
      }, {
        key: "color",
        label: RESX.GeneralLabels.resxColor,
        renderEditNew: () => <div className="main-section-template-fields-padding">
          <ColorPicker
            value={value.hexColor}
            onChange={(c) => { onChange({ hexColor: c }); }}
          />
        </div>,
      }],
    }]}
  />;
}